import { hasTracking } from "@escapio/shared/state/client-settings";
import { hasAllPurposesConsent } from "@escapio/shared/tracker/ConsentObserver";

export async function proxyTrack(eventName, category, id) {
	if (hasTracking) {
		await hasAllPurposesConsent;
		const url = new URL(`https://${window.location.host}/fb-proxy`);
		url.searchParams.append("e", eventName);
		url.searchParams.append("o", window.location.href);
		if (category && id) {
			url.searchParams.append("c", category);
			url.searchParams.append("i", id);
		}
		/* TODO ESC-15764 remove or reactivate
	 	fetch(url);
	 */
	}
}
